import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { Chart, registerables } from 'chart.js';
import configApi from '../../config';

Chart.register(...registerables);

const TrafficByHourChart = () => {
    const chartRef = useRef(null);
    const [chartInstance, setChartInstance] = useState(null);
    const token = localStorage.getItem("token");
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    const fetchTrafficData = async () => {
        try {
            const response = await axios.get(
                `${configApi.apiEndpoint}/api/Stats/TrafficByHour`,
                config
            );
            createChart(response.data);
        } catch (error) {
            console.error('Chyba pri načítavaní hodinovej vyťaženosti:', error);
        }
    };

    const createChart = (data) => {
        const labels = data.map(item => item.hourString);
        const counts = data.map(item => item.count);

        const ctx = chartRef.current.getContext('2d');
        const gradient = ctx.createLinearGradient(0, 0, 0, 300);
        gradient.addColorStop(0, 'rgba(255, 152, 0, 0.5)'); // Orange material design
        gradient.addColorStop(1, 'rgba(255, 152, 0, 0.0)');

        const chartConfig = {
            type: 'line',
            data: {
                labels: labels,
                datasets: [{
                    label: 'Celkový počet rezervácií',
                    data: counts,
                    fill: true,
                    backgroundColor: gradient,
                    borderColor: '#ff9800',
                    borderWidth: 3,
                    tension: 0.4,
                    pointRadius: 3,
                    pointHoverRadius: 6,
                    pointBackgroundColor: '#ff9800',
                    pointBorderColor: '#fff',
                    pointBorderWidth: 2
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    y: {
                        beginAtZero: true,
                        title: {
                            display: true,
                            text: 'Počet termínov'
                        }
                    },
                    x: {
                        title: {
                            display: false
                        }
                    }
                },
                plugins: {
                    legend: {
                        display: false
                    },
                    title: {
                        display: false
                    },
                    tooltip: {
                        callbacks: {
                            title: function (context) {
                                return `Čas: ${context[0].label}`;
                            }
                        }
                    }
                }
            }
        };

        if (chartInstance) {
            chartInstance.data = chartConfig.data;
            chartInstance.options = chartConfig.options;
            chartInstance.update();
        } else {
            const newChartInstance = new Chart(ctx, chartConfig);
            setChartInstance(newChartInstance);
        }
    };

    useEffect(() => {
        fetchTrafficData();
    }, []);

    return (
        <div className="card-custom h-100">
            <div className="card-custom-header">
                <h5 className="m-0">Vyťaženosť podľa hodín</h5>
            </div>
            <div style={{ height: '300px' }}>
                <canvas ref={chartRef}></canvas>
            </div>
        </div>
    );
};

export default TrafficByHourChart;
